function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("g", null, React.createElement("g", null, React.createElement("path", {
  fill: "#272727",
  d: "M1341.1,600.7c-7.1,0-12.8-5.7-12.8-12.8V457.5c0-7.1,5.7-12.8,12.8-12.8c7.1,0,12.8,5.7,12.8,12.8v130.4 C1353.9,595,1348.1,600.7,1341.1,600.7z"
})), React.createElement("g", null, React.createElement("path", {
  fill: "#272727",
  d: "M847.7,600.7c-7.1,0-12.8-5.7-12.8-12.8V457.5c0-7.1,5.7-12.8,12.8-12.8s12.8,5.7,12.8,12.8v130.4 C860.5,595,854.7,600.7,847.7,600.7z"
})), React.createElement("g", null, React.createElement("path", {
  fill: "#272727",
  d: "M952.5,600.7c-7.1,0-12.8-5.7-12.8-12.8V457.5c0-7.1,5.7-12.8,12.8-12.8s12.8,5.7,12.8,12.8v130.4 C965.3,595,959.6,600.7,952.5,600.7z"
})), React.createElement("path", {
  fill: "#57BC80",
  d: "M952.5,600.7c-3.7,0-7.5-1.6-10-4.8L837.7,465.5c-4.4-5.5-3.6-13.6,2-18c5.5-4.4,13.6-3.6,18,2l104.8,130.4 c4.4,5.5,3.6,13.6-2,18C958.2,599.8,955.3,600.7,952.5,600.7z"
}), React.createElement("g", null, React.createElement("path", {
  fill: "#272727",
  d: "M1407.3,600.7c-7.1,0-12.8-5.7-12.8-12.8V457.5c0-7.1,5.7-12.8,12.8-12.8c7.1,0,12.8,5.7,12.8,12.8v130.4 C1420.1,595,1414.3,600.7,1407.3,600.7z"
})), React.createElement("g", null, React.createElement("path", {
  fill: "#272727",
  d: "M1512.1,600.7c-7.1,0-12.8-5.7-12.8-12.8V457.5c0-7.1,5.7-12.8,12.8-12.8s12.8,5.7,12.8,12.8v130.4 C1524.9,595,1519.2,600.7,1512.1,600.7z"
})), React.createElement("path", {
  fill: "#57BC80",
  d: "M1512.1,600.7c-3.7,0-7.5-1.6-10-4.8l-104.8-130.4c-4.4-5.5-3.6-13.6,2-18c5.5-4.4,13.6-3.6,18,2 l104.8,130.4c4.4,5.5,3.6,13.6-2,18C1517.8,599.8,1514.9,600.7,1512.1,600.7z"
}), React.createElement("g", null, React.createElement("path", {
  fill: "#57BC80",
  d: "M1055.3,600.7c-16,0-31.2-6.1-42.7-17.3c-11.2-10.9-17.7-25.3-18.5-40.8c-0.1-0.5-0.1-1-0.1-1.6v-85.4 c0-7.1,5.7-12.8,12.8-12.8c7.1,0,12.8,5.7,12.8,12.8V540c0,0.2,0,0.4,0,0.6c0.3,9.3,4.1,18,10.8,24.4c6.7,6.5,15.5,10.1,24.8,10.1 s18.1-3.6,24.8-10.1c6.7-6.5,10.5-15.2,10.8-24.4c0-0.2,0-0.4,0-0.6v-84.4c0-7.1,5.7-12.8,12.8-12.8c7.1,0,12.8,5.7,12.8,12.8V541 c0,0.5,0,1.1-0.1,1.6c-0.8,15.5-7.3,30-18.5,40.8C1086.5,594.6,1071.4,600.7,1055.3,600.7z"
})), React.createElement("g", null, React.createElement("path", {
  fill: "#272727",
  d: "M1274.9,600.7c-7.1,0-12.8-5.7-12.8-12.8V457.5c0-7.1,5.7-12.8,12.8-12.8s12.8,5.7,12.8,12.8v130.4 C1287.7,595,1282,600.7,1274.9,600.7z"
})), React.createElement("g", null, React.createElement("path", {
  fill: "#272727",
  d: "M1157.9,600.7c-7.1,0-12.8-5.7-12.8-12.8V457.5c0-7.1,5.7-12.8,12.8-12.8c7.1,0,12.8,5.7,12.8,12.8v130.4 C1170.7,595,1165,600.7,1157.9,600.7z"
})), React.createElement("g", null, React.createElement("path", {
  fill: "#57BC80",
  d: "M1216.4,600.7c-5,0-9.6-3-11.7-7.6l-58.6-130.3c-2.9-6.4,0-14,6.4-16.9c6.4-2.9,14,0,16.9,6.4l46.9,104.3 l46.9-104.4c2.9-6.4,10.5-9.3,16.9-6.4c6.4,2.9,9.3,10.5,6.4,16.9L1228,593.2C1226,597.8,1221.4,600.7,1216.4,600.7L1216.4,600.7z "
})), React.createElement("g", null, React.createElement("path", {
  fill: "#57BC80",
  d: "M1562.1,600.7c-1.8,0-3.5-0.4-5.2-1.1c-6.4-2.9-9.3-10.5-6.4-16.9l58.6-130.4c2.1-4.6,6.6-7.6,11.7-7.6h0 c5,0,9.6,3,11.7,7.6l58.6,130.3c2.9,6.4,0,14-6.4,16.9c-6.4,2.9-14,0-16.9-6.4l-46.9-104.3l-46.9,104.4 C1571.7,597.9,1567,600.7,1562.1,600.7z"
})), React.createElement("g", null, React.createElement("path", {
  fill: "#4B9268",
  d: "M857.1,448.8c-0.1-0.1-0.2-0.2-0.3-0.3c-0.1-0.1-0.3-0.3-0.4-0.4c-0.7-0.6-1.4-1.2-2.3-1.7 c-0.1-0.1-0.2-0.1-0.3-0.2c-0.2-0.1-0.4-0.2-0.5-0.3c-0.2-0.1-0.4-0.2-0.6-0.3c-0.1,0-0.1,0-0.2-0.1c-0.9-0.4-1.9-0.6-2.9-0.8 c-0.2,0-0.4-0.1-0.5-0.1c-0.2,0-0.3,0-0.5,0c-0.3,0-0.5,0-0.8,0c-0.2,0-0.3,0-0.5,0c-0.3,0-0.5,0-0.8,0c-0.2,0-0.4,0-0.5,0.1 c-0.2,0-0.5,0.1-0.7,0.1c-0.2,0-0.4,0.1-0.6,0.1c-0.2,0.1-0.4,0.1-0.6,0.2c-0.2,0.1-0.4,0.1-0.6,0.2c-0.2,0.1-0.4,0.1-0.6,0.2 c-0.2,0.1-0.4,0.2-0.6,0.3c-0.2,0.1-0.4,0.2-0.5,0.3c-0.2,0.1-0.4,0.2-0.6,0.4c-0.2,0.1-0.3,0.2-0.5,0.3c-0.2,0.1-0.4,0.3-0.7,0.5 c-0.1,0.1-0.2,0.2-0.4,0.3c-0.2,0.2-0.4,0.4-0.6,0.5c-0.1,0.1-0.2,0.2-0.3,0.3c-0.1,0.1-0.3,0.3-0.4,0.4c-0.6,0.7-1.2,1.5-1.7,2.3 c0,0.1-0.1,0.2-0.1,0.2c-0.1,0.2-0.2,0.4-0.3,0.6c-0.1,0.2-0.2,0.4-0.3,0.6c0,0.1-0.1,0.2-0.1,0.2c-0.4,0.9-0.6,1.9-0.8,2.8 c0,0.2-0.1,0.4-0.1,0.6c0,0.2,0,0.3,0,0.5c0,0.3,0,0.5,0,0.8c0,2.8,0.9,5.7,2.8,8.1l22.8,28.3v-36.4c0-3.1-1.1-5.9-2.9-8.1 C857.4,449.2,857.2,449,857.1,448.8z"
}), React.createElement("path", {
  fill: "#4B9268",
  d: "M1416.6,448.8c-0.1-0.1-0.2-0.2-0.3-0.4c-0.1-0.1-0.3-0.3-0.4-0.4c-0.7-0.6-1.5-1.2-2.3-1.7 c-0.1-0.1-0.2-0.1-0.3-0.2c-0.2-0.1-0.4-0.2-0.5-0.3c-0.2-0.1-0.4-0.2-0.6-0.3c-0.1,0-0.1,0-0.2-0.1c-0.9-0.4-1.9-0.6-2.9-0.8 c-0.2,0-0.3-0.1-0.5-0.1c-0.2,0-0.3,0-0.5,0c-0.3,0-0.5,0-0.8,0c-0.2,0-0.3,0-0.5,0c-0.3,0-0.5,0-0.8,0c-0.2,0-0.4,0-0.5,0.1 c-0.2,0-0.5,0.1-0.7,0.1c-0.2,0-0.4,0.1-0.6,0.1c-0.2,0.1-0.4,0.1-0.6,0.2c-0.2,0.1-0.4,0.1-0.6,0.2c-0.2,0.1-0.4,0.1-0.6,0.2 c-0.2,0.1-0.4,0.2-0.6,0.3c-0.2,0.1-0.4,0.2-0.5,0.3c-0.2,0.1-0.4,0.2-0.6,0.4c-0.2,0.1-0.3,0.2-0.5,0.3c-0.2,0.1-0.4,0.3-0.7,0.5 c-0.1,0.1-0.2,0.2-0.4,0.3c-0.2,0.2-0.4,0.4-0.6,0.5c-0.1,0.1-0.2,0.2-0.3,0.3c-0.1,0.1-0.3,0.3-0.4,0.4c-0.6,0.7-1.2,1.5-1.7,2.3 c0,0.1-0.1,0.2-0.2,0.3c-0.1,0.2-0.2,0.4-0.3,0.5c-0.1,0.2-0.2,0.4-0.3,0.6c0,0.1-0.1,0.1-0.1,0.2c-0.4,0.9-0.6,1.9-0.8,2.8 c0,0.2-0.1,0.4-0.1,0.6c0,0.2,0,0.3,0,0.5c0,0.3,0,0.5,0,0.8c0,2.8,0.9,5.7,2.8,8.1l22.8,28.3v-36.4c0-3.1-1.1-5.9-2.9-8.1 C1417,449.2,1416.8,449,1416.6,448.8z"
}), React.createElement("path", {
  fill: "#4B9268",
  d: "M1152.5,446c-2,0.9-3.6,2.2-4.9,3.9c0,0-0.1,0.1-0.1,0.1c-0.2,0.2-0.3,0.4-0.4,0.6 c-0.2,0.3-0.3,0.5-0.5,0.8c0,0,0,0,0,0c-1,1.8-1.5,3.9-1.5,6.1v1.8c0.2,1.2,0.5,2.4,1,3.6l24.6,54.7v-60.1c0-1.2-0.2-2.3-0.5-3.4 l-0.8-1.7C1166.6,446,1159,443.1,1152.5,446z"
}), React.createElement("path", {
  fill: "#4B9268",
  d: "M962.5,579.9l-22.8-28.3v36.4c0,3.1,1.1,5.9,2.9,8.1c0,0,0.1,0.1,0.1,0.1c0.2,0.3,0.5,0.5,0.7,0.8 c0,0,0,0,0.1,0.1c0.3,0.3,0.6,0.5,0.8,0.8c0,0,0.1,0.1,0.1,0.1c0.3,0.2,0.6,0.5,0.9,0.7c0,0,0,0,0.1,0c0.6,0.4,1.3,0.8,2,1.1 c0.1,0,0.1,0.1,0.2,0.1c0.3,0.1,0.6,0.2,1,0.4c0.1,0,0.2,0.1,0.3,0.1c0.3,0.1,0.7,0.2,1,0.3c0.1,0,0.2,0,0.2,0 c0.4,0.1,0.7,0.1,1.1,0.2c0,0,0.1,0,0.1,0c0.4,0,0.8,0.1,1.2,0.1c0.4,0,0.8,0,1.2-0.1c0.1,0,0.2,0,0.4,0c0.3,0,0.6-0.1,0.8-0.1 c0.1,0,0.3-0.1,0.4-0.1c0.2-0.1,0.5-0.1,0.7-0.2c0.1,0,0.3-0.1,0.4-0.1c0.2-0.1,0.5-0.2,0.7-0.3c0.1-0.1,0.3-0.1,0.4-0.2 c0.3-0.1,0.5-0.2,0.8-0.4c0.1,0,0.2-0.1,0.3-0.1c0.3-0.2,0.7-0.4,1-0.6c0.1-0.1,0.2-0.2,0.3-0.2c0.2-0.2,0.4-0.3,0.6-0.5 c0.2-0.2,0.4-0.4,0.6-0.5c0.1-0.1,0.2-0.2,0.3-0.3c0.1-0.1,0.3-0.3,0.4-0.4c0.6-0.7,1.2-1.5,1.7-2.3c0-0.1,0.1-0.2,0.1-0.2 c0.1-0.2,0.2-0.4,0.3-0.6c0.1-0.2,0.2-0.4,0.3-0.6c0-0.1,0.1-0.2,0.1-0.2c0.4-0.9,0.6-1.9,0.8-2.8c0-0.2,0.1-0.4,0.1-0.6 c0-0.2,0-0.3,0-0.5c0-0.3,0-0.5,0-0.8C965.3,585.2,964.4,582.3,962.5,579.9z"
}), React.createElement("path", {
  fill: "#4B9268",
  d: "M1286.6,462.7c0.7-1.6,1.1-3.3,1.1-5v0c0-0.4,0-0.8,0-1.2c0,0,0,0,0,0c-0.3-4.5-3.1-8.7-7.5-10.7 c-6.4-2.9-14,0-16.9,6.4l-0.6,1.3c-0.3,1.2-0.5,2.4-0.5,3.6v60.1L1286.6,462.7z"
}), React.createElement("path", {
  fill: "#4B9268",
  d: "M1522.1,579.9l-22.8-28.3v36.4c0,3.1,1.1,5.9,2.9,8.1c0,0,0.1,0.1,0.1,0.1c0.2,0.3,0.5,0.5,0.7,0.8 c0,0,0,0,0.1,0.1c0.3,0.3,0.6,0.5,0.8,0.8c0,0,0.1,0.1,0.1,0.1c0.3,0.2,0.6,0.5,0.9,0.7c0,0,0,0,0.1,0c0.6,0.4,1.3,0.8,2,1.1 c0.1,0,0.1,0.1,0.2,0.1c0.3,0.1,0.6,0.2,1,0.4c0.1,0,0.2,0.1,0.3,0.1c0.3,0.1,0.7,0.2,1,0.3c0.1,0,0.2,0,0.2,0 c0.4,0.1,0.7,0.1,1.1,0.2c0,0,0.1,0,0.1,0c0.4,0,0.8,0.1,1.2,0.1c0.4,0,0.8,0,1.2-0.1c0.1,0,0.2,0,0.4,0c0.3,0,0.6-0.1,0.8-0.1 c0.1,0,0.3-0.1,0.4-0.1c0.2-0.1,0.5-0.1,0.7-0.2c0.1,0,0.3-0.1,0.4-0.1c0.2-0.1,0.5-0.2,0.7-0.3c0.1-0.1,0.3-0.1,0.4-0.2 c0.3-0.1,0.5-0.2,0.8-0.4c0.1,0,0.2-0.1,0.3-0.1c0.3-0.2,0.7-0.4,1-0.6c0.1-0.1,0.2-0.2,0.3-0.2c0.2-0.2,0.4-0.3,0.6-0.5 c0.2-0.2,0.4-0.4,0.6-0.5c0.1-0.1,0.2-0.2,0.3-0.3c0.1-0.1,0.3-0.3,0.4-0.4c0.6-0.7,1.2-1.5,1.7-2.3c0-0.1,0.1-0.2,0.2-0.3 c0.1-0.2,0.2-0.4,0.3-0.5c0.1-0.2,0.2-0.4,0.3-0.6c0-0.1,0.1-0.1,0.1-0.2c0.4-0.9,0.6-1.9,0.8-2.8c0-0.2,0.1-0.4,0.1-0.6 c0-0.2,0-0.3,0-0.5c0-0.3,0-0.5,0-0.8C1524.9,585.2,1524,582.3,1522.1,579.9z"
})));

var _ref2 =
/*#__PURE__*/
React.createElement("g", null, React.createElement("path", {
  fill: "#272727",
  d: "M195,61.5c-2.6,0-4.8-2.1-4.8-4.8V8c0-2.6,2.1-4.8,4.8-4.8s4.8,2.1,4.8,4.8v48.7 C199.7,59.3,197.6,61.5,195,61.5z"
}));

var _ref3 =
/*#__PURE__*/
React.createElement("g", null, React.createElement("path", {
  fill: "#272727",
  d: "M10.8,61.5c-2.6,0-4.8-2.1-4.8-4.8V8c0-2.6,2.1-4.8,4.8-4.8s4.8,2.1,4.8,4.8v48.7 C15.6,59.3,13.4,61.5,10.8,61.5z"
}));

var _ref4 =
/*#__PURE__*/
React.createElement("g", null, React.createElement("path", {
  fill: "#272727",
  d: "M49.9,61.5c-2.6,0-4.8-2.1-4.8-4.8V8c0-2.6,2.1-4.8,4.8-4.8s4.8,2.1,4.8,4.8v48.7 C54.7,59.3,52.6,61.5,49.9,61.5z"
}));

var _ref5 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#57BC80",
  d: "M49.9,61.5c-1.4,0-2.8-0.6-3.7-1.8L7.1,11C5.4,8.9,5.7,5.9,7.8,4.3c2.1-1.7,5.1-1.3,6.7,0.7l39.1,48.7 c1.7,2.1,1.3,5.1-0.7,6.7C52,61.1,51,61.5,49.9,61.5z"
});

var _ref6 =
/*#__PURE__*/
React.createElement("g", null, React.createElement("path", {
  fill: "#272727",
  d: "M224.5,8v48.7c0,2.6-2.1,4.8-4.8,4.8s-4.8-2.1-4.8-4.8V8H224.5z"
}));

var _ref7 =
/*#__PURE__*/
React.createElement("g", null, React.createElement("path", {
  fill: "#272727",
  d: "M258.8,61.5c-2.6,0-4.8-2.1-4.8-4.8V8c0-2.6,2.1-4.8,4.8-4.8c2.6,0,4.8,2.1,4.8,4.8v48.7 C263.6,59.3,261.5,61.5,258.8,61.5z"
}));

var _ref8 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#57BC80",
  d: "M258.8,61.5c-1.4,0-2.8-0.6-3.7-1.8L216,11c-1.7-2.1-1.3-5.1,0.7-6.7c2.1-1.7,5.1-1.3,6.7,0.7l39.1,48.7 c1.7,2.1,1.3,5.1-0.7,6.7C260.9,61.1,259.9,61.5,258.8,61.5z"
});

var _ref9 =
/*#__PURE__*/
React.createElement("g", null, React.createElement("path", {
  fill: "#57BC80",
  d: "M88.3,61.5c-6,0-11.6-2.3-15.9-6.5c-4.2-4.1-6.6-9.5-6.9-15.2c0-0.2,0-0.4,0-0.6V7.3c0-2.6,2.1-4.8,4.8-4.8 c2.6,0,4.8,2.1,4.8,4.8v31.5c0,0.1,0,0.1,0,0.2c0.1,3.5,1.5,6.7,4,9.1c2.5,2.4,5.8,3.8,9.3,3.8s6.8-1.3,9.3-3.8 c2.5-2.4,3.9-5.7,4-9.1c0-0.1,0-0.2,0-0.2V7.3c0-2.6,2.1-4.8,4.8-4.8c2.6,0,4.8,2.1,4.8,4.8v31.9c0,0.2,0,0.4,0,0.6 c-0.3,5.8-2.7,11.2-6.9,15.2C99.9,59.2,94.3,61.5,88.3,61.5z"
}));

var _ref10 =
/*#__PURE__*/
React.createElement("g", null, React.createElement("path", {
  fill: "#272727",
  d: "M170.3,61.5c-2.6,0-4.8-2.1-4.8-4.8V8c0-2.6,2.1-4.8,4.8-4.8s4.8,2.1,4.8,4.8v48.7 C175.1,59.3,172.9,61.5,170.3,61.5z"
}));

var _ref11 =
/*#__PURE__*/
React.createElement("g", null, React.createElement("path", {
  fill: "#272727",
  d: "M126.6,61.5c-2.6,0-4.8-2.1-4.8-4.8V8c0-2.6,2.1-4.8,4.8-4.8c2.6,0,4.8,2.1,4.8,4.8v48.7 C131.3,59.3,129.2,61.5,126.6,61.5z"
}));

var _ref12 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#57BC80",
  d: "M148.4,61.5c-1.9,0-3.6-1.1-4.4-2.8L122.2,10c-1.1-2.4,0-5.2,2.4-6.3c2.4-1.1,5.2,0,6.3,2.4L148.4,45 l17.5-39c1.1-2.4,3.9-3.5,6.3-2.4c2.4,1.1,3.5,3.9,2.4,6.3l-21.9,48.7C152,60.4,150.3,61.5,148.4,61.5L148.4,61.5z"
});

var _ref13 =
/*#__PURE__*/
React.createElement("g", null, React.createElement("path", {
  fill: "#57BC80",
  d: "M277.5,61.5c-0.7,0-1.3-0.1-2-0.4c-2.4-1.1-3.5-3.9-2.4-6.3L295,6c0.8-1.7,2.5-2.8,4.4-2.8h0 c1.9,0,3.6,1.1,4.4,2.8l21.9,48.6c1.1,2.4,0,5.2-2.4,6.3c-2.4,1.1-5.2,0-6.3-2.4l-17.5-38.9l-17.5,39 C281.1,60.4,279.3,61.5,277.5,61.5z"
}));

var _ref14 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#4B9268",
  d: "M14.3,4.8c0,0-0.1-0.1-0.1-0.1c-0.1-0.1-0.1-0.1-0.2-0.2c-0.3-0.2-0.5-0.4-0.8-0.6c0,0-0.1,0-0.1-0.1 c-0.1,0-0.1-0.1-0.2-0.1c-0.1,0-0.2-0.1-0.2-0.1c0,0,0,0-0.1,0c-0.3-0.1-0.7-0.2-1.1-0.3c-0.1,0-0.1,0-0.2,0c-0.1,0-0.1,0-0.2,0 c-0.1,0-0.2,0-0.3,0c-0.1,0-0.1,0-0.2,0c-0.1,0-0.2,0-0.3,0c-0.1,0-0.1,0-0.2,0c-0.1,0-0.2,0-0.3,0c-0.1,0-0.1,0-0.2,0.1 c-0.1,0-0.2,0-0.2,0.1c-0.1,0-0.1,0-0.2,0.1C9.1,3.5,9,3.5,9,3.6c-0.1,0-0.2,0.1-0.2,0.1c-0.1,0-0.1,0.1-0.2,0.1 c-0.1,0-0.2,0.1-0.2,0.1C8.3,3.9,8.2,4,8.1,4C8.1,4.1,8,4.1,7.9,4.2c0,0-0.1,0.1-0.1,0.1C7.7,4.4,7.6,4.4,7.5,4.5 c0,0-0.1,0.1-0.1,0.1C7.4,4.7,7.3,4.7,7.3,4.8C7,5,6.8,5.3,6.6,5.6c0,0,0,0.1-0.1,0.1c0,0.1-0.1,0.1-0.1,0.2c0,0.1-0.1,0.1-0.1,0.2 c0,0,0,0.1,0,0.1c-0.1,0.3-0.2,0.7-0.3,1c0,0.1,0,0.1,0,0.2c0,0.1,0,0.1,0,0.2C6,7.8,6,7.9,6,8c0,1.1,0.3,2.1,1.1,3l8.5,10.6V8 c0-1.1-0.4-2.2-1.1-3C14.4,4.9,14.4,4.8,14.3,4.8z"
});

var _ref15 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#4B9268",
  d: "M124.6,3.6c-0.7,0.3-1.4,0.8-1.8,1.4c0,0,0,0,0,0.1c-0.1,0.1-0.1,0.2-0.2,0.2c-0.1,0.1-0.1,0.2-0.2,0.3 c0,0,0,0,0,0c-0.4,0.7-0.6,1.5-0.6,2.3v0.7c0.1,0.5,0.2,0.9,0.4,1.3l9.2,20.4V7.9c0-0.4-0.1-0.9-0.2-1.3L130.9,6 C129.8,3.6,127,2.6,124.6,3.6z"
});

var _ref16 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#4B9268",
  d: "M53.6,53.7l-8.5-10.6v13.6c0,1.1,0.4,2.2,1.1,3c0,0,0,0,0,0.1c0.1,0.1,0.2,0.2,0.3,0.3c0,0,0,0,0,0 c0.1,0.1,0.2,0.2,0.3,0.3c0,0,0,0,0,0c0.1,0.1,0.2,0.2,0.3,0.3c0,0,0,0,0,0c0.2,0.2,0.5,0.3,0.8,0.4c0,0,0,0,0.1,0 c0.1,0,0.2,0.1,0.4,0.1c0,0,0.1,0,0.1,0c0.1,0,0.2,0.1,0.4,0.1c0,0,0.1,0,0.1,0c0.1,0,0.3,0,0.4,0.1c0,0,0,0,0,0c0.1,0,0.3,0,0.5,0 c0.2,0,0.3,0,0.5,0c0,0,0.1,0,0.1,0c0.1,0,0.2,0,0.3,0c0.1,0,0.1,0,0.2,0c0.1,0,0.2,0,0.3-0.1c0.1,0,0.1,0,0.2,0 c0.1,0,0.2-0.1,0.3-0.1c0,0,0.1,0,0.1-0.1c0.1,0,0.2-0.1,0.3-0.1c0,0,0.1,0,0.1-0.1c0.1-0.1,0.3-0.1,0.4-0.2c0,0,0.1-0.1,0.1-0.1 c0.1-0.1,0.2-0.1,0.2-0.2c0.1-0.1,0.2-0.1,0.2-0.2c0,0,0.1-0.1,0.1-0.1c0.1-0.1,0.1-0.1,0.1-0.2c0.2-0.3,0.5-0.5,0.6-0.9 c0,0,0-0.1,0.1-0.1c0-0.1,0.1-0.1,0.1-0.2c0-0.1,0.1-0.1,0.1-0.2c0,0,0-0.1,0-0.1c0.1-0.3,0.2-0.7,0.3-1c0-0.1,0-0.1,0-0.2 c0-0.1,0-0.1,0-0.2c0-0.1,0-0.2,0-0.3C54.7,55.7,54.4,54.6,53.6,53.7z"
});

var _ref17 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#4B9268",
  d: "M174.6,10c0.3-0.6,0.4-1.2,0.4-1.9v0c0-0.2,0-0.3,0-0.5c0,0,0,0,0,0c-0.1-1.7-1.2-3.3-2.8-4 c-2.4-1.1-5.2,0-6.3,2.4l-0.2,0.5c-0.1,0.4-0.2,0.9-0.2,1.4v22.4L174.6,10z"
});

var _ref18 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#4B9268",
  d: "M262.5,53.7L254,43.1v13.6c0,1.1,0.4,2.2,1.1,3c0,0,0,0,0,0.1c0.1,0.1,0.2,0.2,0.3,0.3c0,0,0,0,0,0 c0.1,0.1,0.2,0.2,0.3,0.3c0,0,0,0,0,0c0.1,0.1,0.2,0.2,0.3,0.3c0,0,0,0,0,0c0.2,0.2,0.5,0.3,0.8,0.4c0,0,0,0,0.1,0 c0.1,0,0.2,0.1,0.4,0.1c0,0,0.1,0,0.1,0c0.1,0,0.2,0.1,0.4,0.1c0,0,0.1,0,0.1,0c0.1,0,0.3,0,0.4,0.1c0,0,0,0,0,0c0.1,0,0.3,0,0.5,0 c0.2,0,0.3,0,0.5,0c0,0,0.1,0,0.1,0c0.1,0,0.2,0,0.3,0c0.1,0,0.1,0,0.2,0c0.1,0,0.2,0,0.3-0.1c0.1,0,0.1,0,0.2,0 c0.1,0,0.2-0.1,0.3-0.1c0,0,0.1,0,0.1-0.1c0.1,0,0.2-0.1,0.3-0.1c0,0,0.1,0,0.1-0.1c0.1-0.1,0.3-0.1,0.4-0.2c0,0,0.1-0.1,0.1-0.1 c0.1-0.1,0.2-0.1,0.2-0.2c0.1-0.1,0.2-0.1,0.2-0.2c0,0,0.1-0.1,0.1-0.1c0.1-0.1,0.1-0.1,0.2-0.2c0.2-0.3,0.4-0.5,0.6-0.9 c0,0,0-0.1,0.1-0.1c0-0.1,0.1-0.1,0.1-0.2c0-0.1,0.1-0.1,0.1-0.2c0,0,0-0.1,0-0.1c0.1-0.3,0.2-0.7,0.3-1.1c0-0.1,0-0.1,0-0.2 c0-0.1,0-0.1,0-0.2c0-0.1,0-0.2,0-0.3C263.6,55.7,263.3,54.6,262.5,53.7z"
});

var _ref19 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#4B9268",
  d: "M224.5,8c0-0.6-0.2-2-1.1-3l0,0c-0.9-1.1-2.2-1.8-3.7-1.8c-2.6,0-4.8,2.1-4.8,4.7c0,1.4,0.5,2.4,1,3 l8.5,10.6L224.5,8C224.5,8,224.5,8,224.5,8z"
});

var SvgLogoNumina = function SvgLogoNumina(props) {
  return React.createElement("svg", _extends({
    baseProfile: "tiny",
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 332 64",
    xmlSpace: "preserve"
  }, props), _ref, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19);
};

export default __webpack_public_path__ + "static/media/logo_numina.a8067434.svg";
export { SvgLogoNumina as ReactComponent };